import { useQuery } from "@tanstack/react-query";
import { fetchKPIResults } from "PFCore/services/kpi";
import { Id, QueryOptions } from "PFCore/types";
import { KPIResult } from "PFCore/types/kpi";

import { KPIKeys } from "./query_keys";

type KPIResultsParams = {
  engagementId: Id;
};

export const useKPIResults = <TData = KPIResult[]>(
  { engagementId }: KPIResultsParams,
  options: QueryOptions<KPIResult[], any, TData> = {}
) =>
  useQuery<KPIResult[], any, TData>({
    queryKey: KPIKeys.kpiResults(engagementId),
    queryFn: () => fetchKPIResults(engagementId),
    staleTime: 0,
    retry: false,
    ...options
  });
